import { createAsyncThunk } from "@reduxjs/toolkit";
import EventApi from "@infrastructure/event-api";
import { getErrorPayload } from "@application/helpers/api-helper";
export const EventRegistertionAsync = createAsyncThunk("event/registration", async (registration, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await EventApi.Registeration(registration);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllEventsWithDatesAsync = createAsyncThunk("events/getAllWithDates", async (_, { rejectWithValue }) => {
    try {
        const response = await EventApi.getAllEventsWithDates();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllEventsAsync = createAsyncThunk("events/getAll", async (_, { rejectWithValue }) => {
    try {
        const response = await EventApi.getAllEvents();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getExternalInvitationCountAsync = createAsyncThunk("events/getExternalInvitationCount", async (_, { rejectWithValue }) => {
    try {
        const response = await EventApi.getExternalInvitationCount();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getEventByIdAsync = createAsyncThunk("events/getById", async (eventId, { rejectWithValue }) => {
    try {
        const response = await EventApi.getByEventId(eventId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getEventPublicAccessInfoAsync = createAsyncThunk("events/getPublicAccessInfo", async (eventId, { rejectWithValue }) => {
    try {
        const response = await EventApi.getEventPublicAccessInfo(eventId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const validatePublicPasswordAsync = createAsyncThunk("events/validatePublicPassword", async (query, { rejectWithValue }) => {
    try {
        const response = await EventApi.validatePublicPassword(query);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const validateInitialRegistrationAsync = createAsyncThunk("events/validateInitialRegistration", async (query, { rejectWithValue }) => {
    try {
        const response = await EventApi.validateInitialRegistration(query);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getEventRegistrationInfoAsync = createAsyncThunk("events/getRegistrationInfo", async (query, { rejectWithValue }) => {
    try {
        const response = await EventApi.getEventRegistrationInfo(query);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const verifyUniqueLinkAsync = createAsyncThunk("events/verifyUniqueLink", async ({ id, userType }, { rejectWithValue }) => {
    try {
        const response = await EventApi.verifyUniqueLink(id, userType);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
